import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { map, pluck } from 'rxjs/operators';

import type { Placement } from '@core/placements-types';

@Injectable({ providedIn: 'root' })
export class QuickEvaluationContextService {
  private readonly activatedRoute = inject(ActivatedRoute);

  public findPlacement(placements: Placement[]) {
    return this.activatedRoute.queryParams.pipe(
      pluck('offerId'),
      map(offerId =>
        offerId
          ? placements.find(
              placement => (placement.offerId || placement.talentPoolId) === Number(offerId),
            ) || placements[0]
          : placements && placements.length
            ? placements[0]
            : undefined,
      ),
    );
  }
}
